import SaveIcon from "@mui/icons-material/FileDownloadOutlined";
import { Box, Card, CardMedia, IconButton } from "@mui/material";
import { useState } from "react";
import type { ApiResponse } from "@entrilia/shared/api/types";
import type { FileDownloadInfo } from "@entrilia/shared/api/fileTypes";
import { logError } from "@entrilia/shared/logging";
import { downloadFileFromUrl } from "@entrilia/shared/services/downloadFile";

interface Props {
  fileInfo: FileDownloadInfo;
  // Original fileInfo is not enough: the downloadUrl might expire before user attempts to download / print the file
  getFileDownloadInfoCallback: () => Promise<ApiResponse<FileDownloadInfo>>;
}

const VideoPreview = ({ fileInfo, getFileDownloadInfoCallback }: Props) => {
  const [saving, setSaving] = useState(false);

  const handleDownloadClick = async () => {
    setSaving(true);

    const resp = await getFileDownloadInfoCallback();
    if (resp.data !== undefined) {
      await downloadFileFromUrl(resp.data.downloadUrl);
    } else {
      logError(resp.error, "[VideoPreview] handleDownloadClick");
    }

    setSaving(false);
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", py: 1, px: 2.5 }}>
        <IconButton onClick={handleDownloadClick} loading={saving}>
          <SaveIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, pb: 2 }}>
        <Card sx={{ flexGrow: 1 }} variant="outlined">
          <CardMedia
            component="video"
            controls
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
            src={fileInfo.downloadUrl}
            sx={{ objectFit: "contain", border: 0, height: "100%", bgcolor: "common.black" }}
          />
        </Card>
      </Box>
    </>
  );
};

export default VideoPreview;
